<template>
  <div v-if="products.length > 0">
    <h1 v-translate="'similar_products_hd'"></h1>
    <div id="product-list">
      <ul class='products'>
        <li v-bind:key="product_index" v-for="(product,product_index) in products"
            class="matched accessory kind-u">
          <item :product="product"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import Item from './Item'

  export default {
    name: 'similar',
    props: {
      qty: {
        type: Number,
        default: 3
      },
    },
    components: {Item},
    data () {
      return {
        products: []
      }
    },
    methods: {
      findSimilarAccessories (color) {
        let qty = 0
        let colorIndex = 0
        let that = this
        let found = []
        this.products = [];
        // czas na wyczyszczenie itemów
        setTimeout(() => {

        _.forEach(env.data.accessories, acc => {

          colorIndex = 0
          _.forEach(acc.colors, acccolor => {
            if (acccolor.base_name === color) {
              found.push(acc)
              acc.col_sel = colorIndex
              setTimeout(function () {
                let a = acc.col_sel
                acc.col_sel = 0
                setTimeout(function () {acc.col_sel = a}, 200)

              }, 200)
              qty++
            }
            colorIndex++
          })
          if (qty >= that.qty) { return false }
        })
        this.products = found
        },200);
      }
    },
    created () {
      this.$bus.$on('colorChanged', this.findSimilarAccessories)

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Products/Similar.vue